import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=9e5943c6&scoped=true&"
import script from "./Blog.vue?vue&type=script&lang=js&"
export * from "./Blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5943c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e5943c6')) {
      api.createRecord('9e5943c6', component.options)
    } else {
      api.reload('9e5943c6', component.options)
    }
    module.hot.accept("./Blog.vue?vue&type=template&id=9e5943c6&scoped=true&", function () {
      api.rerender('9e5943c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Blog/Blog.vue"
export default component.exports